import { useSelector} from 'react-redux';

import mediaSettingsSelector from '@Redux/mediaSettings/mediaSettingsSelector';

import BasicLabel from '@Components/BasicComponents/BasicLabel';

import { Row, Select, Space, Typography } from 'antd';
import {CheckOutlined } from '@ant-design/icons';
import InfoTooltip from './InfoTooltip';
import ReactQuill from 'react-quill';
const { Option } = Select;
const { Compact } = Space;
const {Text} = Typography;

import "react-quill/dist/quill.snow.css";

export default function MultiLanguageRichText ({
	title,
	value: values,
	onChange,
	countryCode,
	setCountryCode,
	error = {isOk: true},
	tooltip = null,
  required = false,
}) {
	const {languages} = useSelector(mediaSettingsSelector);

	const handleChangeText = (value) => {
		onChange({countryCode, value});
	};

	return (
		<Compact block size="middle" direction='vertical'>
			<Row justify="space-between" align="middle">
				<BasicLabel
					title={title}
					tooltip={tooltip}
					required={required}
				/>
				<Space>
					<InfoTooltip
						text="To indicate and define the language in which the media content is presented. English is mandatory for the required fields."
						style={{marginRight: 20}}
					/>
					<Select
						value={countryCode}
						style={{ width: 150 }}
						onChange={setCountryCode}
						loading={languages.loading}
					>
						{
							languages.data?.map(({id, nameIso}) =>
								<Option key={id} value={id}>
									<Space>
										{nameIso}
										{values?.[id] &&  values?.[id] !== '' && <CheckOutlined />}
									</Space>
								</Option>)
						}
					</Select>
				</Space>
			</Row>
			<br/>
			<ReactQuill
				value={values && values[countryCode]}
				onChange={handleChangeText}
				lineHeight={1.5}
				modules={{
					toolbar: [
						['bold', 'italic', 'underline', 'link'],
					],
				}}
				className="rich-text-editor"
			/>
			<Text type={error.type === 'error' ? 'danger' : 'warning'}>{error?.text}</Text>
		</Compact>
	);
}